// Copyright (c) 2019 Comsearch, Inc., All rights reserved

import {
  stringMustBeNumber,
  valueIsRequired,
} from 'validators/common/simple'

const requiredStringMustBeNumber = v => (
  valueIsRequired(v) ||
  stringMustBeNumber(v)
)

export default requiredStringMustBeNumber
